import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {getStorage} from '../../helpers/utilities'
import {AuthModel, initialAuthModel} from '../../interfaces/auth'
import {LoginResponse} from '../api/interfaces/auth'

function getInitialAuthData(): AuthModel {
  if (!process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY) {
    return initialAuthModel
  }

  const authData = getStorage<AuthModel>(process.env.REACT_APP_AUTH_LOCAL_STORAGE_KEY)
  if (authData) return authData

  return initialAuthModel
}

const initialState: AuthModel = getInitialAuthData()

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<LoginResponse>) => {
      state.session_id = action.payload.info.sessionId
      state.user = action.payload.responseContent.user
      state.enterprise = action.payload.responseContent.enterprise
    },
    updateCurrentUser: (state, action: PayloadAction<{name: string; phoneNumber: string}>) => {
      state.user = {
        id: state.user?.id || '',
        emailAddress: state.user?.emailAddress || '',
        username: state.user?.username || '',
        enterpriseId: state.user?.enterpriseId || '',
        type: state.user?.type || 'admin',
        name: action.payload.name,
        phoneNumber: action.payload.phoneNumber,
      }
    },
    logoutUser: (state) => {
      state.session_id = null
      state.user = null
      state.enterprise = null
    },
  },
})

export const {setCurrentUser, updateCurrentUser, logoutUser} = authSlice.actions

export default authSlice.reducer
